module.exports = __webpack_public_path__ + "img/ring_y_o_null_1.817272ba.png";